/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios';
import QS from 'qs';
import Vue from 'vue';

import Router from '../router/index';

const _this = new Vue(); 
let sha256 = require("js-sha256").sha256;
let key = '779fc181f3ee8a780bdffeca47b05b9f';
let project_name = 'szgdjy';

export const _baseURL = 'http://cms.szgdjy.com';
export const baseURL = '/domain';


// 环境的切换
// if (process.env.NODE_ENV == 'development') {    
//     axios.defaults.baseURL = '';
// } else if (process.env.NODE_ENV == 'debug') {    
//     axios.defaults.baseURL = baseURL;
// } else if (process.env.NODE_ENV == 'production') {    
//     axios.defaults.baseURL = '';
// }

// 请求超时时间
axios.defaults.timeout = 1200000;


// 请求拦截器
// axios.interceptors.request.use(    
//     config => {
//         // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
//         // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
//         //* const token = store.state.token;        
//         token && (config.headers.Authorization = token);        
//         return config;    
//     },    
//     error => {        
//         return Promise.error(error);    
//     })

// 响应拦截器
axios.interceptors.response.use(    
    response => {     
        if (response.status === 200) {            
            return Promise.resolve(response);        
        } else {            
            return Promise.reject(response);        
        }    
    },
    // 服务器状态码不是200的情况    
    error => {  
        console.log(error)      
        if (error.response.status) {
            switch (error.response.status) {                
                // 401: 未登录                
                // 未登录则跳转登录页面，并携带当前页面的路径                
                // 在登录成功后返回当前页面，这一步需要在登录页操作。                
                case 401: 
                    sessionStorage.clear();
                    _this.$message.error(_this.$i18n.t('LoginUseService'))  
                    Router.push({name: 'Login'});
                    break;
                case 403: 
                    sessionStorage.clear();
                    _this.$message.error(_this.$i18n.t('AccountLoginExpiredOrLoggedInWhere'))  
                    setTimeout(() => {
                        Router.push({name: 'Login'});
                    }, 2000)
                    break;
                // 其他错误，直接抛出错误提示                
                default:                    
                    _this.$message({                        
                        message: error.response.data.errmsg,                        
                        duration: 1500,                        
                        type: 'error'                 
                    });            
            }            
            return Promise.reject(error.response);        
        }       
    }
);
/** 
 * get方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function get(url, params){    
    return new Promise((resolve, reject) =>{ 
        axios({
            method: 'get',
            // baseURI: api.domain, // QA Server
            url: _baseURL + url,
            data: params,
            withCredentials: true,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(res => {
            resolve(res.data);     
        }).catch(err => {
            reject(err.data)        
        });   
    });
}
/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function post(url, params) {
    let sign = getParamsSign(params);
    // console.log(sign)
    // console.log(sha256(sign))
    return new Promise((resolve, reject) => {     
        axios({
            method: 'post',
            // baseURI: api.domain, // QA Server
            url: _baseURL + url,
            data: params,
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Methods': 'POST,OPTIONS',
                sign: sha256(sign),
                xtoken: sessionStorage.getItem('token')
            }
        })
        .then(res => {
            resolve(res.data);     
        }).catch(err => {
            reject(err.data)        
        });  
    });
}

function getParamsSign (params) {
    let sign = [];
    let connector = '&';
    if (params) {
        let keyArr = Object.keys(params);
        for (let item of keyArr) {
            if (params[item] !== undefined && params[item] !== null) {
                let type = typeof(params[item]);
                if (type == 'object') {
                    // console.log(item + '=' + JSON.stringify(params[item]))
                    sign.push(item + '=' + JSON.stringify(params[item]))
                } else {
                    // console.log(item + '=' + params[item])
                    sign.push(item + '=' + params[item])
                }
            } else {
                sign.push(item + '=')
            }
        }
    }
    sign.push('$key=' + key);
    sign.push('$project_name=' + project_name);
    sign.sort();
    return sign.join(connector);
}


// WEBPACK FOOTER //
// ./src/axios/index.js